function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

import { BasePlugin } from '@uppy/core';
import getSocketHost from '@uppy/utils/lib/getSocketHost';
import { RateLimitedQueue } from '@uppy/utils/lib/RateLimitedQueue';
import { Provider, RequestClient, Socket } from '@uppy/companion-client';
import uuid from 'react-uuid';
import sanitizeFileName from '../../utils/sanitizeFileName';
var defaultOptions = {
  limit: 20
};

var _queueRequestSocketToken = /*#__PURE__*/_classPrivateFieldLooseKey("queueRequestSocketToken");

var _fetchFile = /*#__PURE__*/_classPrivateFieldLooseKey("fetchFile");

var _setFileState = /*#__PURE__*/_classPrivateFieldLooseKey("setFileState");

var _loadingStatus = /*#__PURE__*/_classPrivateFieldLooseKey("loadingStatus");

var _getFile = /*#__PURE__*/_classPrivateFieldLooseKey("getFile");

var _setFile = /*#__PURE__*/_classPrivateFieldLooseKey("setFile");

var _temporaryFileMeta = /*#__PURE__*/_classPrivateFieldLooseKey("temporaryFileMeta");

var _uploadRemoteFile = /*#__PURE__*/_classPrivateFieldLooseKey("uploadRemoteFile");

var _requestSocketToken = /*#__PURE__*/_classPrivateFieldLooseKey("requestSocketToken");

var _connectToServerSocket = /*#__PURE__*/_classPrivateFieldLooseKey("connectToServerSocket");

var RemoteImageDownloader = /*#__PURE__*/function (_BasePlugin) {
  _inherits(RemoteImageDownloader, _BasePlugin);

  var _super = _createSuper(RemoteImageDownloader);

  function RemoteImageDownloader(uppy, _opts) {
    var _this;

    _classCallCheck(this, RemoteImageDownloader);

    _this = _super.call(this, uppy, _opts);
    Object.defineProperty(_assertThisInitialized(_this), _connectToServerSocket, {
      value: _connectToServerSocket2
    });
    Object.defineProperty(_assertThisInitialized(_this), _temporaryFileMeta, {
      value: _temporaryFileMeta2
    });
    Object.defineProperty(_assertThisInitialized(_this), _setFile, {
      value: _setFile2
    });
    Object.defineProperty(_assertThisInitialized(_this), _getFile, {
      value: _getFile2
    });
    Object.defineProperty(_assertThisInitialized(_this), _loadingStatus, {
      get: _get_loadingStatus,
      set: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), _setFileState, {
      value: _setFileState2
    });
    Object.defineProperty(_assertThisInitialized(_this), _queueRequestSocketToken, {
      writable: true,
      value: void 0
    });

    _this.addFile = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file) {
        var _yield$_classPrivateF, url, _classPrivateFieldLoo;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(file.isRemote && file.type.startsWith('image/'))) {
                  _context.next = 20;
                  break;
                }

                file.meta.source = file.source;
                _context.prev = 2;
                _context.next = 5;
                return _classPrivateFieldLooseBase(_assertThisInitialized(_this), _uploadRemoteFile)[_uploadRemoteFile](file);

              case 5:
                _yield$_classPrivateF = _context.sent;
                url = _yield$_classPrivateF.url;

                if (!url) {
                  _context.next = 11;
                  break;
                }

                _context.next = 10;
                return _classPrivateFieldLooseBase(_assertThisInitialized(_this), _fetchFile)[_fetchFile](file, url);

              case 10:
                return _context.abrupt("return", _context.sent);

              case 11:
                throw new Error('Cannot add a file');

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](2);
                (_classPrivateFieldLoo = _classPrivateFieldLooseBase(_assertThisInitialized(_this), _loadingStatus)[_loadingStatus]) === null || _classPrivateFieldLoo === void 0 ? void 0 : _classPrivateFieldLoo.hide();

                _this.uppy.log("[RemoteImageDownloader] ".concat(_context.t0.message, ", ").concat(_context.t0.stack), 'error');

                _this.uppy.info('Failed to fetch this file', 'error');

                return _context.abrupt("return", null);

              case 20:
                return _context.abrupt("return", file);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 14]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    Object.defineProperty(_assertThisInitialized(_this), _fetchFile, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file, url) {
          var _classPrivateFieldLoo2;

          var addedFile, response, blob, currentFile, addedFileId;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return fetch(url, {
                    headers: _this.opts.headers
                  });

                case 2:
                  response = _context2.sent;
                  _context2.next = 5;
                  return response.blob();

                case 5:
                  blob = _context2.sent;
                  currentFile = _objectSpread(_objectSpread({}, file), {}, {
                    data: blob,
                    isRemote: false,
                    preview: null,
                    serverToken: null
                  });
                  _context2.prev = 7;
                  addedFileId = _this.uppy.addFile(currentFile);
                  addedFile = _this.uppy.getFile(addedFileId);

                  _this.uppy.emit('thumbnail:request', addedFile);

                  _context2.next = 17;
                  break;

                case 13:
                  _context2.prev = 13;
                  _context2.t0 = _context2["catch"](7);

                  // Catch Uppy errors to allow for specific messaging to users about file format violations
                  // such as filesize or type, then re-throw the error.
                  _this.uppy.info(_context2.t0.message, 'error');

                  throw _context2.t0;

                case 17:
                  (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(_assertThisInitialized(_this), _loadingStatus)[_loadingStatus]) === null || _classPrivateFieldLoo2 === void 0 ? void 0 : _classPrivateFieldLoo2.hide();
                  return _context2.abrupt("return", addedFile);

                case 19:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[7, 13]]);
        }));

        function value(_x2, _x3) {
          return _value.apply(this, arguments);
        }

        return value;
      }()
    });
    Object.defineProperty(_assertThisInitialized(_this), _uploadRemoteFile, {
      writable: true,
      value: function () {
        var _value2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(file) {
          var _classPrivateFieldLoo3;

          var serverToken;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this.resetUploaderState(file.id);

                  (_classPrivateFieldLoo3 = _classPrivateFieldLooseBase(_assertThisInitialized(_this), _loadingStatus)[_loadingStatus]) === null || _classPrivateFieldLoo3 === void 0 ? void 0 : _classPrivateFieldLoo3.show();

                  _classPrivateFieldLooseBase(_assertThisInitialized(_this), _setFile)[_setFile](file);

                  if (!_classPrivateFieldLooseBase(_assertThisInitialized(_this), _getFile)[_getFile](file.id).serverToken) {
                    _context3.next = 5;
                    break;
                  }

                  return _context3.abrupt("return", _classPrivateFieldLooseBase(_assertThisInitialized(_this), _connectToServerSocket)[_connectToServerSocket](_classPrivateFieldLooseBase(_assertThisInitialized(_this), _getFile)[_getFile](file.id)));

                case 5:
                  _context3.next = 7;
                  return _classPrivateFieldLooseBase(_assertThisInitialized(_this), _queueRequestSocketToken)[_queueRequestSocketToken](_classPrivateFieldLooseBase(_assertThisInitialized(_this), _getFile)[_getFile](file.id));

                case 7:
                  serverToken = _context3.sent;

                  _classPrivateFieldLooseBase(_assertThisInitialized(_this), _setFileState)[_setFileState](file.id, {
                    serverToken: serverToken
                  });

                  return _context3.abrupt("return", _classPrivateFieldLooseBase(_assertThisInitialized(_this), _connectToServerSocket)[_connectToServerSocket](_classPrivateFieldLooseBase(_assertThisInitialized(_this), _getFile)[_getFile](file.id)));

                case 10:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function value(_x4) {
          return _value2.apply(this, arguments);
        }

        return value;
      }()
    });

    _this.resetUploaderState = function (fileId) {
      if (_this.sockets[fileId]) {
        _this.sockets[fileId].close();

        _this.sockets[fileId] = null;
      }

      if (_this.files[fileId]) {
        _this.files[fileId] = null;
      }
    };

    Object.defineProperty(_assertThisInitialized(_this), _requestSocketToken, {
      writable: true,
      value: function () {
        var _value3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(file) {
          var Client, client, opts, res;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  Client = file.remote.providerOptions.provider ? Provider : RequestClient;
                  client = new Client(_this.uppy, file.remote.providerOptions);
                  opts = _objectSpread({}, _this.opts);

                  if (file.tus) {
                    // Install file-specific upload overrides.
                    Object.assign(opts, file.tus);
                  }

                  _context4.next = 6;
                  return client.post(file.remote.url, _objectSpread(_objectSpread({}, file.remote.body), {}, {
                    endpoint: opts.endpoint,
                    uploadUrl: opts.uploadUrl,
                    protocol: 'tus',
                    size: file.data.size,
                    headers: opts.headers,
                    metadata: _classPrivateFieldLooseBase(_assertThisInitialized(_this), _temporaryFileMeta)[_temporaryFileMeta](file.meta)
                  }));

                case 6:
                  res = _context4.sent;
                  return _context4.abrupt("return", res.token);

                case 8:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function value(_x5) {
          return _value3.apply(this, arguments);
        }

        return value;
      }()
    });
    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), _opts); // these hold sockets and files info for multi uploads

    _this.sockets = {};
    _this.files = {};
    _this.id = _this.opts.id || 'RemoteImageDownloader';
    _this.type = 'modifier'; // Rate limited requests queue that is across all uploads with this plugin

    _this.requests = new RateLimitedQueue(_this.opts.limit);
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _queueRequestSocketToken)[_queueRequestSocketToken] = _this.requests.wrapPromiseFunction(_classPrivateFieldLooseBase(_assertThisInitialized(_this), _requestSocketToken)[_requestSocketToken]);
    return _this;
  }
  /**
   * @param  {Object} file - A file to download
   * @returns  {Object|null} - Added file or null
   */


  _createClass(RemoteImageDownloader, [{
    key: "install",
    value: function install() {
      this.uppy.log('Installing RemoteImageDownloader');
    }
  }]);

  return RemoteImageDownloader;
}(BasePlugin);

function _setFileState2(fileId, attributes) {
  if (!this.files[fileId]) {
    throw new Error("Can't set state for ".concat(fileId));
  }

  this.files[fileId] = _objectSpread(_objectSpread({}, this.files[fileId]), attributes);
}

function _get_loadingStatus() {
  return this.uppy.getPlugin('LoadingStatus');
}

function _getFile2(id) {
  return this.files[id];
}

function _setFile2(file) {
  this.files[file.id] = file;
}

function _temporaryFileMeta2(meta) {
  return _objectSpread(_objectSpread({}, meta), {}, {
    name: "".concat(uuid(), "_").concat(sanitizeFileName(meta.name)),
    tempfile: true
  });
}

function _connectToServerSocket2(file) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    var queuedRequest;
    var token = file.serverToken;
    var host = getSocketHost(file.remote.companionUrl);
    var socket = new Socket({
      target: "".concat(host, "/api/").concat(token)
    });
    _this2.sockets[file.id] = socket;
    socket.on('error', function (errData) {
      _this2.resetUploaderState(file.id);

      queuedRequest.done();
      reject(new Error(errData.error.message, {
        cause: errData.error
      }));
    });
    socket.on('success', function (data) {
      _this2.resetUploaderState(file.id);

      queuedRequest.done();
      resolve(data);
    });
    queuedRequest = _this2.requests.run(function () {
      socket.open();
      return function () {
        return _this2.resetUploaderState(file.id);
      };
    });
  });
}

export { RemoteImageDownloader as default };